const currencyDefinitions = {
  SEK: 'kr',
  EUR: '€',
  BGN: 'Лв.'
}

export default (currencyCode) => {
  return currencyDefinitions[currencyCode]
}
